var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiringSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75L12 18.75L12 2.75L10 2.75L10 18.75ZM5 18.75L7 18.75L7 6.75L5 6.75L5 18.75ZM0 18.75L2 18.75L2 0.75L-7.86805e-07 0.75L0 18.75Z",
    fill: "#576EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringSuccess);
export default __webpack_public_path__ + "static/media/hiring-success.688ea44756b82593243b71db4db4adea.svg";
export { ForwardRef as ReactComponent };